import React from 'react';

import Modal from './';
import ModalCard from './ModalCard';
import Button from '../Button';
import { Row, Section } from '../Layout';
import LoadingSpinner from 'components/UIComponents/LoadingSpinner';

export default ({
  title = 'Kinnita valik',
  children,
  open,
  onCancel,
  onConfirm,
  loading = false,
  confirmText = 'Jätka',
  cancelText = 'Loobu',
}) => (
  <Modal show={open} onClose={onCancel} closeOnBlur={!loading}>
    <ModalCard>
      <ModalCard.Head>
        <ModalCard.Title>{title}</ModalCard.Title>
      </ModalCard.Head>
      <LoadingSpinner loading={loading} />
      <ModalCard.Body>
        <Section className="vertical-padding-md">{children}</Section>
      </ModalCard.Body>
      <ModalCard.Foot>
        <Row>
          <Button
            onClick={onCancel}
            className="mr-2"
            id="cancelConfirmationButton"
            disabled={loading}
          >
            &#215; {cancelText}
          </Button>
          <Button
            color="primary"
            onClick={onConfirm}
            id="confirmButton"
            disabled={loading}
          >
            {confirmText}
          </Button>
        </Row>
      </ModalCard.Foot>
    </ModalCard>
  </Modal>
);
